<template>
    <div class="select-flow">
        <svg id="icon_layer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2892.16 792.05"><defs></defs><title>Logo-BTCDirect</title><path class="cls-1" d="M528.34,146.17,561.36,24H465.6l-19.81,76c-17.61-6.61-36.32-11-55-14.31L407.27,24H311.51L296.1,83.44C213.56,94.44,137.61,137.37,87,204.51-18.68,342.09,7.73,540.21,145.32,645.87L112.3,768H207l19.81-75.94c17.61,6.6,36.33,11,55,14.31L265.29,768h94.65l16.51-59.43C459,697.6,535,654.68,585.58,587.54,692.34,448.85,665.92,251.84,528.34,146.17ZM336.83,469.77a74.85,74.85,0,1,1,74.84-74.85C411.67,436.75,378.65,469.77,336.83,469.77Z"/><path class="cls-1" d="M590,713c0-9.91-6.61-15.41-17.61-15.41H553.66v42.93h11V728.42h8.81l6.6,12.11h12.11l-9.91-13.21C587.78,725.12,591.08,719.61,590,713Zm-9.91,0c0,4.4-2.2,7.7-6.6,7.7h-8.81v-14.3h7.71c3.3-1.1,6.6,2.2,7.7,5.5Z"/><path class="cls-1" d="M571.27,675.59a46.23,46.23,0,1,0,46.22,46.23C616.39,696.5,596.58,675.59,571.27,675.59Zm0,81.45a35.23,35.23,0,1,1,35.22-35.22A34.77,34.77,0,0,1,571.27,757Z"/><path class="cls-1" d="M1072.06,392.72c35.22-7.7,58.34-34.12,58.34-75.94,0-50.63-37.42-83.65-95.76-83.65H888.26V558.92H1039c59.44,0,96.86-35.22,96.86-90.25C1135.9,425.74,1109.49,397.12,1072.06,392.72Zm-95.75-96.86h35.22A32,32,0,0,1,1041.25,330v4.41c-1.1,17.61-16.51,30.81-35.22,29.71H976.31ZM1044.55,461c-1.1,17.61-17.61,31.92-36.32,29.72H977.41V420.24h36.32a33.24,33.24,0,0,1,30.82,35.22Z"/><polygon class="cls-1" points="1152.41 315.68 1230.56 316.77 1230.56 558.92 1320.81 558.92 1320.81 316.77 1397.86 316.77 1397.86 233.13 1152.41 233.13 1152.41 315.68"/><path class="cls-1" d="M1575.47,310c36.7,0,59.37,19.61,65.85,49h92.85c-6.48-85-66.94-134-158.7-134-97.16,0-164.1,70.8-164.1,171,0,99.12,65.86,171,164.1,171,91.76,0,151.14-49,158.7-134h-92.85c-5.4,29.41-29.15,49-65.85,49-45.34,0-72.33-32.67-72.33-86.05S1530.13,310,1575.47,310Z"/><path class="cls-1" d="M1871.75,233.13h-90.26V558.92h90.26c100.16,0,154.09-79.25,154.09-162.9S1971.91,233.13,1871.75,233.13Zm-2.2,296.07h-59.44V261.74h59.44c83.65,0,126.57,66,126.57,134.28C1996.12,463.16,1953.2,529.2,1869.55,529.2Z"/><path class="cls-1" d="M2087.85,248.54c-14.31,1.1-25.32,13.2-24.22,27.51v3.3c1.1,14.31,13.21,25.32,27.52,24.22s25.31-13.21,24.21-27.52v-3.3C2114.26,258.44,2102.16,247.43,2087.85,248.54Z"/><rect class="cls-1" x="2075.19" y="346.49" width="28.62" height="212.43"/><path class="cls-1" d="M2199.74,402.63V346.49h-27.51V557.82h27.51V466.46c0-46.22,17.61-95.75,62.74-95.75,6.6,0,12.11,0,18.71,1.1V344.29a96.38,96.38,0,0,0-17.61-2.2C2235,342.09,2208.55,360.8,2199.74,402.63Z"/><path class="cls-1" d="M2403.36,341c-57.23,0-95.75,42.93-95.75,111.17s37.42,112.26,96.85,112.26c44,0,79.25-27.51,86.95-66H2463.9c-8.81,24.22-33,40.73-59.44,38.53-40.72,0-68.24-29.72-68.24-77h158.5c0-6.6,1.1-13.21,0-19.81C2494.72,382.81,2458.39,341,2403.36,341Zm-67.14,94.66c2.2-41.83,27.52-70.45,67.14-70.45s63.84,28.62,64.94,70.45Z"/><path class="cls-1" d="M2627.89,369.61c35.23,0,57.24,16.51,62.74,49.53h27.52c-5.51-47.33-39.63-77.05-90.26-77.05-60.53,0-97.95,44-97.95,110.07s37.42,111.16,97.95,112.26c51.74,0,85.86-29.71,90.26-75.94h-27.52c-5.5,31.92-28.61,48.43-62.74,48.43-42.92,0-69.34-33-69.34-83.65S2585,369.61,2627.89,369.61Z"/><path class="cls-1" d="M2843.62,534.71c-18.71,0-34.12-6.61-34.12-50.64V372.91h53.93V346.49H2809.5V276.05H2782v70.44h-37.43v26.42H2782V489.58c0,66,31.91,71.54,56.13,71.54,11,1.1,22-1.1,31.92-3.3V530.3C2861.23,532.5,2852.43,533.6,2843.62,534.71Z"/></svg>
        <h4 style="text-align: center; margin: 0; margin-top: 10px;">
            Buy and sell XRP with BTC Direct
        </h4>
        <p style="text-align: center; margin: auto; font-size: 0.8rem;">{{ walletAddress }}</p>

        <LoaderSpinner v-if="loading" style="margin: auto;"/>

        <template v-else>
            <div class="tc-info" v-if="tcAccept !== true">
                <p>By agreeing to the terms of this User Agreement, you declare that you have read, understood and agree with the content and agree to our Privacy Statement and disclaimer.</p>

                <p>BTC Direct is a third-party on- & off-ramp service provider. You will be redirected to BTC Direct's widget and website. XRPL Labs is not responsible for the content or services provided by BTC Direct or any damages or loss it may cause to you due to the use of BTC Direct's services. Please contact BTC Direct directly for any issues and do read the terms of service of BTC Direct.</p>
            </div>

            <div class="select-flow-buttons">
                <template v-if="tcAccept === true">
                    <button @click="$router.replace({ name: 'buy', query: { walletAddress, fiatType } })" class="btn green">Buy</button>
                    <button @click="$router.replace({ name: 'sell', query: { walletAddress, fiatType } })" class="btn red">Sell</button>
                    <button @click="$router.replace({ name: 'history', query: { walletAddress, fiatType } })" class="btn blue">History</button>
                </template>
                <button class="btn blue" @click="acceptTermsAndConditions()" v-else>Accept</button>
            </div>
        </template>
    </div>
</template>

<script>
import LoaderSpinner from '@/components/LoaderSpinner.vue'

export default {
  name: 'App',
  components: { LoaderSpinner },
  data() {
    return {
        flow: null,
        walletAddress: null,
        fiatType: null,
        tcAccept: false,
        loading: true,
        userData: null
    }
  },
  methods: {
    alert(msg) {
        alert(msg)
    },
    async acceptTermsAndConditions() {
        this.loading = true
        await this.setUserData('onboarding', { init: true })
        this.tcAccept = true
        this.loading = false
    },
    async getTokenData (ott) {
        try {
            const res = await fetch('https://xumm.app/api/v1/xapp-jwt/authorize', {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'x-api-key': process.env.VUE_APP_XAPP_KEY,
                    'x-api-ott': ott
                }
            })
            const data = await res.json()
            this.userData = data

            window.xappJWTxumm = data.jwt

            this.walletAddress = data.ott.account
            this.fiatType = data.ott.currency
            return this.userData
        } catch(e) {
            throw 'Error getting Token Data'
        }
    },
    async setUserData (key, payloadJSON) {
        try {
            const res = await fetch(`https://xumm.app/api/v1/xapp-jwt/userdata/${key}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.userData.jwt || window.xappJWTxumm}`
                },
                body: JSON.stringify(payloadJSON)
            })

            if(res.status < 200 || res.status > 299) {
                throw `Status: ${res.status}`
            }

        } catch(e) {
            console.error('Post userData to XUMM:', e)
            alert(`Error with setting user data ${e}`)
        }
    },
    async getUserData (key) {
        try {
            const res = await fetch(`https://xumm.app/api/v1/xapp-jwt/userdata/${key}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${this.userData.jwt || window.xappJWTxumm}`
                }
            })

            if(res.status < 200 || res.status > 299) {
                throw `${res.status}`
            }

            const body = await res.json()
            return body.data
        } catch(e) {
            console.error('Error getting userData from XUMM', e)
            throw e
        }
    },
    checkUserData() {
        const access = this.userData.ott.accountaccess
        const node = this.userData.ott.nodetype
        if(access !== 'FULL' && node !== 'MAINNET') throw 'This xApp cannot be opened with a "Read Only" account and with a NodeType is not set to MAINNET, please change this in the "Advanced" settings menu'
        if(access !== 'FULL') throw 'This xApp cannot be opened with a "Read Only" account, please switch to an account that is able to sign with "Full Access"'
        if(node !== 'MAINNET') throw 'This xApp cannot be opened with this NodeType, please change this in the "Advanced" settings menu to "MAINNET"'
    },
    async onboardingCheck() {
      try {
        const dataresult = await this.getUserData('onboarding')
        console.log(JSON.stringify(dataresult))
        console.log('Init value: ', dataresult?.onboarding?.init)
        if ( (dataresult?.onboarding?.init !== 'false' || dataresult?.onboarding?.init !== false) && dataresult?.onboarding?.init != undefined) {
          this.tcAccept = true
          return
        }
        console.log('init: ', this.tcAccept)
      } catch (e) {
        alert(`Error getting userData from XUMM ${e}`)
      }
    }
  },
  async mounted() {
    try {
        const urlParams = new URLSearchParams(window.location.search)
        const ott = urlParams.get('xAppToken')
        const data = await this.getTokenData(ott)

        try {
            this.checkUserData()
        } catch(e) {
            alert(e)
            return window.xapp.close()
        }

        if(data?.ott?.origin?.data?.url !== undefined) {
            const urlString = new URL(data.ott.origin.data.url)
            let params = urlString.searchParams

            if(params.has('path')) {
                const path64 = params.get('path')
                const path = atob(path64)
                params.delete('path')

                const query = Object.fromEntries(params)
                this.$router.push({ path, query })
            }
        }
        await this.onboardingCheck()
    } catch(e) {
        console.error(e)
        alert(e)
    }
    this.loading = false
  }
}
</script>


<style scoped>
.select-flow {
    display: flex;
    flex-direction: column;
    padding: 20px;
    align-content: center;
    height: calc(100vh - 40px);
    max-width: 460px;
    margin: auto;
}
.cls-1 {
    fill: #0086fb;
}
.select-flow-buttons {
    display: flex;
    justify-content: space-evenly;
    margin-top: auto;
    flex-direction: column;
}
.tc-info {
    border: 1px solid rgb(0 134 251);
    border-radius: 5px;
    background-color: rgb(0 134 251 / 50%);
    margin: auto;
    padding: 0 15px;
}
.select-flow .btn {
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 0.5rem;
    color: #666;
    display: inline-block;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
    padding: 0.375rem 0.75rem;
    text-align: center;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    user-select: none;
    vertical-align: middle;
    white-space: normal;
    cursor: pointer;

    width: auto;
    margin-bottom: 15px;
}
.select-flow .btn.red {
    background-color: #bd2a1f;
    border-color: #bd2c1f ;
    color: #fff;
}
.select-flow .btn.green {
    background-color: #6bbd1f;
    border-color: #6bbd1f;
    color: #fff;
}
.select-flow .btn.blue {
    background-color: rgb(0, 134, 251);
    border-color: rgb(0, 134, 251);
    color: #fff;
}
.select-flow .btn:disabled,
.select-flow .btn[disabled] {
  cursor: not-allowed;
  background-color: #6a6a6a52 !important;
  color: grey !important;
  border-color: transparent;
}
</style>
